import { AccordionProvider } from "stories";
import Acquisition from "./elements/acquisition/Acquisition";
import Appraisal from "./elements/appraisal/Appraisal";
import EnvironmentalReport from "./elements/environmentalReport/EnvironmentalReport";
import Financing from "./elements/financing/Financing";
import GeotechnicalReport from "./elements/geotechnicalReport/GeotechnicalReport";
import MarketStrategy from "./elements/marketStrategy/MarketStrategy";
import ProposedOverview from "./elements/overview";
import Permits from "./elements/permits/Permits";
import Schedule from "./elements/schedule/Schedule";

const proposedProjectLoanTypeForm = {
  "existing property": [
    ProposedOverview,
    EnvironmentalReport,
    GeotechnicalReport,
    Acquisition,
    Financing,
    Appraisal,
  ],
  construction: [
    ProposedOverview,
    Permits,
    EnvironmentalReport,
    GeotechnicalReport,
    Acquisition,
    Financing,
    Appraisal,
    Schedule,
    MarketStrategy,
  ],
};

export const ProposedProjectFields = ({ opportunity, onUpdate }) => {
  if (!opportunity) return <></>;

  return (
    <AccordionProvider scrollOnChange>
      {proposedProjectLoanTypeForm[opportunity.loan_type].map(
        (AccardionCard, i) => {
          return (
            <AccardionCard
              key={i}
              opportunity={opportunity}
              onUpdate={onUpdate}
            />
          );
        }
      )}
    </AccordionProvider>
  );
};
